import query from './query';

export default {
  Query: query,
};
